
export default {
  props: {
    error: {
      type: Object,
      required: true,
    },
  },

  computed: {
    homeUrl() {
      return this.$getUrl('home');
    },
  },
};
